import { Paper, Stack, Typography } from '@mui/material';

interface BoardColumnDragPreviewProps {
  name: string;
  cardCount: number;
}

// Floating preview shown by DndKit's <DragOverlay> while a column is
// being dragged in "Edit columns" mode. Shows just the column header
// chrome (not the full card list) for a lighter visual signal.
export function BoardColumnDragPreview({
  name,
  cardCount,
}: BoardColumnDragPreviewProps) {
  return (
    <Paper
      variant="outlined"
      sx={{
        width: '100%',
        boxShadow: 8,
        transform: 'rotate(-1deg)',
        backgroundColor: 'background.paper',
        cursor: 'grabbing',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} p={1}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          {name} ({cardCount})
        </Typography>
      </Stack>
    </Paper>
  );
}
